import React, { useEffect } from "react";
import { Form, Input, Modal as AntdModal, Icon, InputNumber,Row,Col, useState } from "antd";


const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
}; 

const Modal = (props) => {

  const { current,visible ,onCancel=()=>{},onConfirm=()=>{} }=props;

  const handleConfirm=()=>{
    onConfirm()   
  }
 
  return ( 
    <AntdModal
      destroyOnClose={true}
      title={"解除安装"}
      visible={visible}
      onOk={handleConfirm}
      onCancel={onCancel} 
      width={710}
      wrapClassName={"modal"} 
    > 
        <div style={{display:'flex',alignItems:'center'}}><Icon type="info-circle" theme="filled"  style={{marginRight:10,color:"#FAAD14"}}/>确定解除设备安装？解除后设备暂不能使用。</div>
    </AntdModal>
  );
};

export default Form.create()(Modal);
